module.exports = __webpack_public_path__ + "media/images/top/works05-2bab32ea06dbe68e5298a1452958ea3e.jpg";